import React, { ReactNode } from "react";
import { MenuItem, Skeleton, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export interface FormFieldSkeletonProps {
  id?: string;
  margin?: "none" | "dense" | "normal";
  fullWidth?: boolean;
  variant?: "standard" | "outlined" | "filled";
  label?: string;
  select?: boolean;
  initialValue?: string;
  required?: boolean;
}

const FormFieldSkeleton = ({
  margin = "normal",
  fullWidth = true,
  variant = "standard",
  label,
  select = false,
  initialValue,
  required = false,
  id,
}: FormFieldSkeletonProps): ReactNode => {
  const { t } = useTranslation();
  if (id) {
    label = t(`${id}`);
  }
  return (
    <TextField
      fullWidth={fullWidth}
      select={select}
      label={label}
      variant={variant}
      margin={margin}
      required={required}
      InputProps={{
        readOnly: true,
        startAdornment: !select && initialValue === undefined && (
          <Skeleton
            variant={"text"}
            sx={{ fontSize: "1rem", width: "100%", cursor: "default" }}
            animation={"pulse"}
          />
        ),
      }}
      inputProps={{
        style: { cursor: "default" },
      }}
      defaultValue={select ? "loading" : initialValue}
    >
      {select && (
        <MenuItem value={"loading"}>
          {initialValue ? (
            <Typography textTransform={"capitalize"} variant="body1">
              {initialValue}
            </Typography>
          ) : (
            <Skeleton variant={"rectangular"} animation={"pulse"} />
          )}
        </MenuItem>
      )}
    </TextField>
  );
};

export default FormFieldSkeleton;
